import { type FC } from 'react';
import {
  LangBase,
  type LangProps,
  useLangBase,
  type UseLangHook,
} from '@pushwoosh/dumb-components/polyglot';

import { type PolyglotMessages } from './type';

// Typed wrappers bound to this app's message catalogue.
export const useLang: UseLangHook<PolyglotMessages> = useLangBase;
export const Lang = LangBase as FC<LangProps<PolyglotMessages>>;

// Shared translate-function type for helpers that take `lang` as a parameter.
export type LangFn = ReturnType<typeof useLang>;

export { LanguageProvider, useLanguage } from './LanguageProvider';
export {
  SUPPORTED_LANGUAGES,
  DEFAULT_LANGUAGE,
  getLanguageDescriptor,
  type LanguageDescriptor,
} from './languages';
